import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { CourseService } from './course.service';
import { CourseSession } from './course-session.model';

@Injectable({
    providedIn: 'root',
})
export class CourseSessionsService {
    isLoading:boolean = false;
    isAdd:boolean = false;
    isEditable:boolean = false;
    errorMessage:string = '';
    sessions: CourseSession[];

    constructor(
        private apiService: ApiService,
        private courseService: CourseService
    ) {}

    get(): void {
        this.errorMessage = '';
        this.isLoading = true;

        this.apiService.getCourseSessions(this.course, {status: "All"}).subscribe(
            (data) => {
                this.sessions = data.map((session) => {return new CourseSession(session);});
                this.isLoading = false;
            },
            (error) => {
                this.isLoading = false;
                this.sessions = [];
                this.errorMessage =
                    'An error occurred, and we were unable to load Sessions for this Course.';
            }
        );
    }

    get course() {
        return this.courseService.course;
    }

}
